import { useHistory } from 'react-router-dom';
import { HTTPStatusCodes } from 'constants/httpStatusCodes';
import { EntityRoutes } from 'routes/constants';
import strings from 'strings';
import FPActionButton from 'UI/components/atoms/FPActionButton';
import ContentPageLayout from 'UI/components/templates/ContentPageLayout';
import EmptyPlaceholder from 'UI/components/templates/EmptyPlaceholder';
import {
  CandidateEntity,
  CompanyEntity,
  ContactEntity,
  JobOrderEntity
} from 'UI/constants/entityTypes';
import {
  SvgNoCandidates,
  SvgNoCompanies,
  SvgNoHiringAuthority,
  SvgNoJobOrders
} from 'UI/res/icons/milano';

const EMPTY_STATE_HEIGHT = 400;
const { serverError: SERVER_ERROR_COPIES, profiles: NOT_FOUND_COPIES } = strings.shared.errors;
const COPIES = strings.inventoryProfiles.common;

const EMPTY_STATES = {
  candidate: {
    id: 'candidate',
    Icon: SvgNoCandidates,
    listRoute: EntityRoutes.Candidates,
    title: CandidateEntity.title
  },
  company: {
    id: 'company',
    Icon: SvgNoCompanies,
    listRoute: EntityRoutes.Companies,
    title: CompanyEntity.title
  },
  jobOrder: {
    id: 'joborder',
    Icon: SvgNoJobOrders,
    listRoute: EntityRoutes.JobOrders,
    title: JobOrderEntity.title
  },
  hiringAuthority: {
    id: 'hiringAuthority',
    Icon: SvgNoHiringAuthority,
    listRoute: EntityRoutes.Contacts,
    title: ContactEntity.title
  },
  contact: {
    id: 'name',
    Icon: SvgNoCandidates,
    listRoute: EntityRoutes.Contacts,
    title: ContactEntity.title
  }
};

const reloadPage = () => window.location.reload();

/**
 * Same criteria as V1's ProfileUiStateManager: 400/404 are "not found" with a way back to
 * the list; anything else is the server error with "Try again".
 * @param {Object} props
 * @param {number} props.statusCode HTTP status of the failed request
 * @param {string} [props.entityType] Key of EMPTY_STATES. ContactProfileV2Route has no entity yet, so it defaults to contact
 * @param {() => void} [props.onRetry] Defaults to reloading the page
 */
export const ProfileEmptyState = ({ statusCode, entityType = 'contact', onRetry = reloadPage }) => {
  const history = useHistory();
  const { id, Icon, listRoute, title } = EMPTY_STATES[entityType];
  const isNotFound =
    statusCode === HTTPStatusCodes.BadRequest || statusCode === HTTPStatusCodes.NotFound;
  const copies = isNotFound ? NOT_FOUND_COPIES[id].notFound : SERVER_ERROR_COPIES;

  return (
    <ContentPageLayout>
      <EmptyPlaceholder
        customEmptyState={<Icon height={EMPTY_STATE_HEIGHT} />}
        subtitle={copies.subtitle}
        title={copies.title}
      >
        <FPActionButton
          onClick={isNotFound ? () => history.push(listRoute) : onRetry}
          text={
            isNotFound ? strings.formatString(COPIES.goToList, { entity: title }) : COPIES.tryAgain
          }
        />
      </EmptyPlaceholder>
    </ContentPageLayout>
  );
};
